import { Actions } from './Actions';
import { Asset, AssetCollection } from '../assets/Asset'
import { AttachmentCollection } from '../Attachment';
import { BuildingCollection } from '../Building';
import { CategoryCollection, Category } from '../Categories'
import { Configuration } from '../Configuration';
import { Cookie } from '../Cookies'
import { Drawing } from '../drawings/Drawing'
import { DrawingsCollection } from '../drawings/DrawingsCollection'
import { exists } from '../utils';
import { Finding, FindingCollection } from '../Findings'
import { Id_building, Id_drawing, Id_floor, Id_workorder, Id_location, Id_collection, Id_category, Id_finding, id_category_list_to_string, id_category_list_from_string } from '../api/Identifiers'
import { Keys, APP_KEYS } from './Datastore'
import { Map, fromJS } from 'immutable'
import { Point } from '../Point'
import { QueryString } from '../QueryString';
import { Rectangle } from '../Rectangle'
import { remove_pushpin_menu_item, show_pushpin_menu_item } from '../ui/menu/PushpinMenu'
import { update_the_drawing_history } from '../DrawingHistory'
import { Workorder } from '../workorders/Workorder'
import { WorkordersCollection } from '../workorders/WorkordersCollection'

let _get_state_function: any;
let _prev_state_function: any;

export function get_state(): State {
    return State.wrap(_get_state_function());
}

export function prev_state(): State {
    return State.wrap(_prev_state_function());
}

export function did_any_change(keys: string[]): boolean {
    return get_state().did_any_change(prev_state(), keys);
}


export function what_changed(): string[] {  // NOT CHEAP.
    return get_state().what_changed(prev_state());
}
export function did_change(key: string): boolean {
    return get_state().did_change(prev_state(), key);
}

export function state_initializer(get_state_function: any, get_prev_state_function: any) {
    _get_state_function = get_state_function;
    _prev_state_function = get_prev_state_function;
}



export class State {
    private _imm_state: Map<any, any>;
    private static _categories: CategoryCollection = CategoryCollection.empty;
    private static _workorders: WorkordersCollection = WorkordersCollection.empty_collection;
    private static _assets: AssetCollection = AssetCollection.empty();
    private static _attachments: AttachmentCollection = new AttachmentCollection();
    private static _drawings_info: any = {};

    private static _findings: FindingCollection = FindingCollection.empty();
    private static _buildings: BuildingCollection = BuildingCollection.empty();
    private static _drawings: DrawingsCollection = DrawingsCollection.build_from_raw([]);//.empty();

    private set(key: string, value: any): State {
        return new State(this._imm_state.set(key, value));
    }

    private get(key: string, default_value?: any): any {
        let r: any = this._imm_state.get(key);
        if (!r) {
            return default_value;
        }

        return r
    }

    public get_number_or_null(key: string): number {
        let r = this._imm_state.get(key);
        if (r === undefined) {
            return null;
        }
        if (r === null) {
            return null;
        }
        if (typeof (r) === typeof ("")) {
            let r_num = parseInt(r)
            if (isNaN(r)) {
                console.error(`NaN ${r} found at ${key}`)
                return null;
            }
            return r_num;
        }
        if (typeof (r) === typeof (123)) {
            return r;
        }
        console.error(`NaN ${r} found at ${key}`)
        return null;
    }



    public get_boolean(key: string, default_value?: boolean): boolean {
        let r: any = this._imm_state.get(key);
        if (default_value === null) {
            default_value = false;
        }
        if (r === null) {
            return default_value;
        }
        if (typeof (r) === typeof ("")) {
            return (<string>r).toLocaleLowerCase() === "true";
        }
        if (typeof (r) === typeof (123)) {
            return r === 1;
        }
        if (typeof (r) === typeof (false)) {
            return r;
        }
        return false
    }

    public set_boolean(key: string, val: boolean): State {
        return this.set(key, val);
    }

    public get_number(key: string, default_val: number): number {
        let r = this.get_number_or_null(key);
        if (!exists(r)) {
            r = default_val;
        }
        return r
    }



    public delete(key: string): State {
        return new State(this._imm_state.delete(key));
    }
    get_string(key: string, default_val?: string): string {
        let r = this._imm_state.get(key);
        if (!exists(r)) {
            r = default_val;
        }
        return r
    }
    get_string_or_null(key: string): string {
        return this.get_string(key, null)
    }
    public toImmutable(): Map<any, any> {
        return this._imm_state;
    }

    constructor(imm_state: Map<any, any>) {
        this._imm_state = imm_state;
    }

    public static wrap(state: Map<any, any>): State {
        if (state === null) {
            return null;
        }
        return new State(state)
    }

    get selected_findings_categories(): Id_category[] {
        return this.get_array(Keys.MENU_FINDINGS_SELECTED, []).map((id_val) => { return Id_category.wrap(id_val); });
    }
    get state_creating_finding(): boolean {
        return this.get_boolean(Keys.STATE_CREATING_FINDING);
    }
    get state_creating_asset(): boolean {
        return this.get_boolean(Keys.STATE_CREATING_ASSET);
    }
    get id_floor(): Id_floor {
        return Id_floor.wrap(this.get_number_or_null(Keys.ID_FLOOR))
    }

    // get api_token(): string {
    //     return this.get_string(Keys.API_TOKEN);
    // }

    // get enabled_feature_assets(): boolean {
    //     return this.get_boolean(Keys.ENABLED_FEATURE_ASSETS);
    // }

    // get enabled_feature_findings(): boolean {
    //     return this.get_boolean(Keys.ENABLED_FEATURE_FINDINGS);
    // }
    get enabled_feature_spotshadow(): boolean {
        return this.get_boolean(Keys.ENABLED_FEATURE_SPOTSHADOW);
    }

    //     get id_segment(): number {
    //         return new QueryString().id_segment;
    // //        return this.get_number_or_null(Keys.ID_SEGMENT);
    //     }

    get menu_attachments_selected(): boolean {
        return this.get_boolean(Keys.KEY_MENU_ATTACHMENTS_SELECTED, false);
    }

    get mouse_cursor(): string {
        return this.get_string(Keys.KEY_MOUSE_CURSOR);
    }

    get site_code(): string {
        return this.customer_name
    }
    get customer_name(): string {
        return this.get_string(Keys.CUSTOMER_NAME);
    }

    get id_customer(): number {
        return this.get_number_or_null(Keys.ID_CUSTOMER);
    }

    get downloaded_findings_floors(): Id_collection {
        return Id_collection.fromJson(this.get_array(Keys.DOWNLOADED_FINDINGS_FLOORS, []));
    }

    get drawing_p0(): Point {
        let p0 = this.get_array(Keys.DRAWING_P0, null);
        if (!p0) {
            return Point.NULL;
        }
        return Point.build_from_array(p0);
    }

    get drawing_p1p2(): Rectangle {
        let p1p2 = this.get_array(Keys.DRAWING_P1P2, null);
        if (!exists(p1p2)) {
            return null;
        }
        if (!exists(p1p2[0])) {
            return null;
        }
        //console.log(`ERROR: '${p1p2}'`);
        return Rectangle.build_from_arrays(p1p2[0], p1p2[1]);
    }

    get buildings(): BuildingCollection {
        return State._buildings;
    }
    get building_p1p2(): Rectangle {
        let p1p2 = this.get_array(Keys.BUILDING_P1P2, null);
        if (!p1p2) {
            return null;
        }
        if (!p1p2[0]) {
            return null;
        }
        if (!p1p2[1]) {
            return null;
        }

        return Rectangle.build_from_arrays(p1p2[0], p1p2[1]);
    }

    get id_drawing(): Id_drawing {
        let temp = this.get_string_or_null(Keys.ID_DRAWING);
        if (!temp) {
            return null;
        }
        return Id_drawing.wrap(temp);
    }

    get nudge_overlapping(): boolean {
        return false;
    }

    get tiles_url(): string {
        let temp: string = this.get_string_or_null(Keys.TILES_URL);
        if (!temp) {
            return null;
        }
        return temp;
    }

    get initial_id_building(): Id_building {
        return Id_building.wrap(this.get_number_or_null(Keys.KEY_INITIAL_ID_BUILDING));
    }

    get initial_id_floor(): Id_floor {
        return Id_floor.wrap(this.get_number_or_null(Keys.KEY_INITIAL_ID_FLOOR));
    }

    get selected_building_drawings(): DrawingsCollection {
        if (exists(this.id_building)) {
            return State._drawings.get_all_in_building(this.id_building);
        }
        return DrawingsCollection.empty;
    }
    get all_drawings(): DrawingsCollection {
        return State._drawings
    }

    public set_downloaded_findings_floors(floors: Id_collection): State {
        return this.set_array(Keys.DOWNLOADED_FINDINGS_FLOORS, floors.toJson());
    }

    private set_hash(key: string): State {
        return this.set_number(key, window.performance.now());
    }

    public set_drawings_data(drawings: DrawingsCollection): State {
        State._drawings = drawings;
        return this.set_number(Keys.HASH_DATA_FLOORPLANS, window.performance.now()).set_number(Keys.HASH_BUILDINGS_DATA, window.performance.now());
    }

    public set_drawings_info_data(drawings_info: any): State {
        State._drawings_info = drawings_info;  // drawings_info  data is too large to store in the immutable object
        let retVal: State = this.set_hash(Keys.HASH_DRAWINGS_INFO_DATA);
        retVal = retVal.set_hash(Keys.HASH_DATA_FLOORPLANS);
        retVal = retVal.set_hash(Keys.HASH_BUILDINGS_DATA);
        let id_drawing: Id_drawing = this.id_drawing;
        if (exists(id_drawing)) {
            let drawing: Drawing = this.all_drawings.get_drawing_from_drawing_id(id_drawing);
            retVal = retVal.set_drawing(drawing);
        }
        return retVal;
    }



    public get all_displayable_drawings(): DrawingsCollection {
        return this.all_drawings.displayable_drawings;  // drawings_info  data is too large to store in the immutable object
    }
    public get drawings_info_data(): any {
        return State._drawings_info;  // drawings_info  data is too large to store in the immutable object
    }

    get api_gateway(): string {
        return this._imm_state.get(Keys.API_GATEWAY);
    }

    get supported_browser(): boolean {
        return this._imm_state.get(Keys.SUPPORTED_BROWSER);
    }

    public get_array(key: string, default_val?: any[]): any[] {
        let ret_val: any = this._imm_state.get(key);
        if (undefined === default_val) {
            default_val = null;
        }
        if (!ret_val) {
            ret_val = null;
            return default_val;
        }
        if (typeof (ret_val.toJS) === typeof (function () { })) {
            ret_val = ret_val.toJS()

        }

        if (ret_val === null) {
            ret_val = default_val;
        }
        if (!Array.isArray(ret_val)) {
            if (Object.keys(ret_val).length === 0) {
                // this was an empty array that was returned as an object
                return []
            }
            console.error("get_array(" + key + ") Non-array returned ")
            ret_val = default_val;
        }
        return ret_val;
    }
    public get id_building(): Id_building {
        let temp = this.get_number(Keys.ID_BUILDING, null);
        if (!temp) {
            return null;
        }
        return Id_building.wrap(temp);
    }

    public get is_debug(): boolean {
        return this.get_boolean(Keys.DEBUG_ENABLED);
    }

    public get assets(): AssetCollection {
        return State._assets;
    }

    public get attachments(): AttachmentCollection {
        return State._attachments;
    }

    public set_assets(assets: AssetCollection): State {
        let r: State = this.set_obj(Keys.DATA_ASSET_IDS, assets.toJSON());
        State._assets = assets;
        // update assets json
        let sorted_by_floor_json: any = {}  // json of all assets in this floor
        if (this.id_floor) {
            sorted_by_floor_json = assets.sorted_by_floor_json();
        }
        r = r.set_obj(Keys.DATA_ASSETS, sorted_by_floor_json)
        return r;
    }

    public set_attachments(attachments: AttachmentCollection): State {
        State._attachments = attachments;
        return this.set_number(Keys.ATTACHMENTS_DATA_HASH, window.performance.now()).set_obj(Keys.KEY_DATA_ALL_ATTACHMENTS, attachments.as_json_by_floor);
    }

    public get fetching_findings(): boolean {
        return this.get_boolean(Keys.STATE_FETCHING_FINDINGS);
    }

    public get printing_findings(): boolean {
        return this.get_boolean(Keys.STATE_PRINTING_FINDINGS);
    }

    public get findings(): FindingCollection {
        return State._findings;
    }

    public get menu_finding_categories_selected(): Id_category[] {
        return id_category_list_from_string(this.get_array(Keys.MENU_FINDINGS_SELECTED, []));
    }

    public get menu_assets_expanded(): boolean {
        return this.get_boolean(Keys.MENU_ASSETS_EXPANDED, true);
    }
    public get menu_asset_categories_selected(): Id_category[] {
        return id_category_list_from_string(this.get_array(Keys.MENU_ASSETS_SELECTED, []));
    }
    public get menu_buildings_expanded(): boolean {
        return this.get_boolean(Keys.MENU_BUILDINGS_EXPANDED, true);
    }

    public set_menu_asset_categories_selected(cats: Id_category[]): State {
        return this.set_array(Keys.MENU_ASSETS_SELECTED, id_category_list_to_string(cats));
    }
    public set_menu_buildings_show(show: boolean): State {
        return this.set_boolean(Keys.MENU_BUILDINGS_SHOW, show);
    }
    public get menu_buildings_show(): boolean {
        return this.get_boolean(Keys.MENU_BUILDINGS_SHOW, true);
    }

    public get menu_workorders_expanded(): boolean {
        return this.get_boolean(Keys.MENU_WORKORDERS_EXPANDED, true);
    }
    public get menu_workorders_selected(): string[] {
        return this.get_array(Keys.MENU_WORKORDERS_SELECTED, [])
    }

    public set_fetching_findings(is_fetching: boolean): State {
        return this.set_boolean(Keys.STATE_FETCHING_FINDINGS, is_fetching);
    }

    public set_printing_findings(is_printing: boolean): State {
        return this.set_boolean(Keys.STATE_PRINTING_FINDINGS, is_printing);
    }

    public set_findings(findings: FindingCollection): State {
        let r: State = this;//.set_obj(Keys.DATA_FINDING_IDS, findings.toJSON());
        State._findings = findings;
        // update assets json
        let sorted_by_floor_json: any = {}  // json of all assets in this floor
        if (this.id_floor) {
            sorted_by_floor_json = findings.sorted_by_floor_json();
        }
        r = r.set_obj(Keys.DATA_FINDINGS, sorted_by_floor_json)
        return r;
    }

    public set_id_building(id_building: Id_building): State {
        if (id_building) {
            return this.set_number(Keys.ID_BUILDING, id_building.value);
        }
        return this.clear(Keys.ID_BUILDING);;
    }

    public get categories(): CategoryCollection {
        return State._categories;
    }
    public set_categories(cats: CategoryCollection): State {
        let r: State = this.set_obj(Keys.KEY_DATA_CATEGORIES, cats.toJSON());
        State._categories = cats;
        return r;
    }

    public get workorders(): WorkordersCollection {
        return State._workorders;
    }

    public set_workorders(wo: WorkordersCollection): State {
        if(exists(this.drawing_p1p2)){
             // the adjusted coords may need to be updated
             wo.translate_workorders(this.drawing_p1p2, this.id_floor, this.drawing_p0, this.nudge_overlapping)
        }
        let r: State = this.set_obj(Keys.DATA_WORKORDERS_JSON, wo.toJSON());
        State._workorders = wo;
        return r;
    }

    public get workorders_query(): any {
        return this.get_json(Keys.WORKORDERS_QUERY, {})

    }

    public set_workorders_query(workorders_query:any): State {
        return this.set(Keys.WORKORDERS_QUERY, workorders_query);

    }

    public static FROM_JS(some_json: any): State {
        return new State(fromJS(some_json));
    }
    public set_obj(key: string, val: any): State {
        return new State(this._imm_state.set(key, fromJS(val)));
    }
    public set_array(key: string, val: any[]): State {
        return State.wrap(this._imm_state.set(key, fromJS(val)));
    }
    // AWH todo: why does this return a State not obj?
    public get_obj(key: string, default_val: any): State { 
        let r: any = this._imm_state.get(key)
        if (r === null) {
            return default_val;
        }
        return r;
    }
    public get_json(key: string, default_val: any) {

        let r: any = this.get_obj(key, null)
        if (!r) {
            return default_val;
        }
        if (typeof (r.toJS) !== 'undefined') {
            r = r.toJS()
        }
        return r;

    }
    public set_mouse_crosshair(is_mouse_crosshair: boolean): State {
        if (is_mouse_crosshair) {
            return this.set_string(Keys.KEY_MOUSE_CURSOR, "crosshair");
        }
        return this.set_string(Keys.KEY_MOUSE_CURSOR, "auto");
    }
    public set_number(key: string, value: number): State {
        return State.wrap(this.set(key, value.toString()).toImmutable());
    }
    public set_string(key: string, value: string): State {
        return State.wrap(this.set(key, value).toImmutable());
    }
    public set_drawing(drawing: Drawing): State {
        let temp: State = this.set_number(Keys.ID_FLOOR, drawing.id_floor.value);
        temp = temp.set_string(Keys.ID_DRAWING, drawing.id.value);
        temp = temp.set_number(Keys.ID_BUILDING, drawing.id_building.value);
        temp = temp.set_boolean(Keys.KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP, drawing.is_sitemap);

        update_the_drawing_history(drawing.id);

        let p1p2: Rectangle = drawing.geoRef;
        if (!exists(p1p2.toArray())) {
            console.error("Issue!!!! P1p2 is undefined")
        }
        temp = temp.set_array(Keys.DRAWING_P0, drawing.p0.toArray());
        temp = temp.set_array(Keys.DRAWING_P1P2, p1p2.toArray());
        temp = temp.set_string(Keys.TILES_URL, drawing.tiles_url);

        //        let drawing_metadata:any =this.drawings_info_data[drawing.id.value]
        //let tiles_url:string = drawing.tiles_url;
        // let p1 = drawing_metadata.anchor.p1;
        // let p2 = drawing_metadata.anchor.p2;

        // let b1 = drawing_metadata.anchor.b1;
        // let b2 = drawing_metadata.anchor.b2;

        let black_list:number[] = [165756, 165751, 165757]
        if (drawing.building_geo_ref !== null) {
            var is_black_listed:boolean = false;
            for (var num of black_list){
                if(drawing.id_building.value == num){
                    console.log("building id is on black list");
                    is_black_listed = true;
                    break;
                }
            }
            if (is_black_listed){
                console.log("building id " + drawing.id_building.value + " is on black list");
                temp=temp.clear(Keys.BUILDING_P1P2);
                remove_pushpin_menu_item();
            }
            else{
                temp = temp.set_array(Keys.BUILDING_P1P2, drawing.building_geo_ref.toArray());
                show_pushpin_menu_item();
            }
            
        }
        else {
            temp=temp.clear(Keys.BUILDING_P1P2);
            temp = temp.set_pushpin_coord(null);
            temp = temp.set_boolean(Keys.KEY_MENU_PUSHPIN_SELECTED, false)
            // dispatch(ts_temp__actions.ACTION_SET_PUSHPIN_COORD, coord
            remove_pushpin_menu_item();

        }

        // Cookie.write(Keys.ID_DRAWING, drawing.id.value);
        // Cookie.write(Keys.ID_FLOOR, drawing.id_floor.value.toString());
        return temp;
    }

    public set_allow_3D_link_create(link_allowed: boolean): State {
        return this.set_boolean(Keys.ALLOW_3D_LINK_CREATE, link_allowed);
    }

    public set_allow_photo_attachment_create(link_allowed: boolean): State {
        return this.set_boolean(Keys.ALLOW_PHOTO_ATTACHMENT_CREATE, link_allowed);
    }


    public set_pushpin_coord(point: Point | null): State {
        if (!point) {
            return this.clear(Keys.KEY_DATA_PUSHPIN_COORDS);
        }
        return this.set_obj(Keys.KEY_DATA_PUSHPIN_COORDS, point.toArray());
    }

    public get pushpin_coord(): Point | null {
        let coords: any[] = this.get_array(Keys.KEY_DATA_PUSHPIN_COORDS);
        if (!coords) {
            return null;
        }

        return Point.build_from_array(coords);
    }

    public set_build_id(build_id: string): State {
        return this.set_string(Keys.KEY_BUILD_ID, build_id);
    }
    
    public get build_id(): string {
        return this.get_string(Keys.KEY_BUILD_ID, "UNDEFINED");
    }

    public set_buildings(buildings: BuildingCollection): State {
        State._buildings = buildings
        return this.set_number(Keys.HASH_BUILDINGS_DATA, window.performance.now()).set_number(Keys.HASH_DATA_FLOORPLANS, window.performance.now());
    }

    public set_building_wo_count(building_wo_count: any | null): State {
        return this.set(Keys.KEY_BUILDING_WO_COUNT, building_wo_count);
    }

    public get building_wo_count(): any | null {
        let building_wo_count: any = this.get_json(Keys.KEY_BUILDING_WO_COUNT, {});
        console.log("building_wo_count: " + building_wo_count)
        return building_wo_count;
    }


    public set_selected_findings_categories(selected_findings: Id_category[]): State {
        return this.set_array(Keys.MENU_FINDINGS_SELECTED, id_category_list_to_string(selected_findings));//.map((id_val)=>{return Id_category.wrap(id_val);});
    }


    public set_token_is_bad(token_is_bad: boolean): State {
        return this.set(Keys.TOKEN_IS_BAD, token_is_bad);
    }

    public get token_is_bad(): boolean {
        let token_is_bad: boolean = this.get(Keys.TOKEN_IS_BAD);
        return token_is_bad;
    }

    public clear(key: string): State {
        return State.wrap(this.delete(key).toImmutable());
    }


    public did_any_change(rhs: State | null, keys: String[]): boolean {
        let r: boolean = false;
        if (!rhs) {
            rhs = prev_state();
        }
        keys.forEach(key => {
            if (this.did_change(rhs, key)) {
                r = true;
            }
        });
        return r;
    }

    private is_equal(rhs: State, key: String): boolean {
        if (this._imm_state == null) {
            return rhs._imm_state == null
        }


        let v1 = rhs._imm_state.get(key)
        let v2 = this._imm_state.get(key)
        if (typeof (v1) !== typeof (v2)) {
            return false; // the types don't match. something changed.  ususally this means one is set, and one is undefined.
        }
        if (v1 == null) {
            return v2 == null;
        }
        if (v2 == null) {
            return v1 == null;
        }
        if (v1 == undefined) {
            return v2 == undefined;
        }
        if (v2 == undefined) {
            return v1 == undefined;
        }

        if (typeof v1.equals !== typeof v2.equals) {
            return false;
        }

        if (typeof v1.equals === 'function') {
            return v1.equals(v2);
        }
        return v1 === v2

    }

    public did_change(rhs: State, key: String): boolean {
        return !this.is_equal(rhs, key);
    }

    public what_changed(other_state: State): string[] {
        let r: string[] = [];
        APP_KEYS().forEach((key: string) => {
            if (this.did_change(other_state, key)) {
                r.push(key)
            }
        })

        return r;
    }

    public get current_query_string(): string {
        let r: string = `?`
    
        let id_building: Id_building = get_state().id_building
        let id_drawing: Id_drawing = get_state().id_drawing
    
        r += `${QueryString.KEY_R_API_GATEWAY}=${QueryString.api_gateway}`;
        r += `&${QueryString.KEY_R_API_TOKEN}=${QueryString.api_token}`;
        r += `&${QueryString.KEY_R_CUSTOMER_NAME}=${QueryString.customer_name}`;
        r += `&${QueryString.KEY_R_ID_SEGMENT}=${QueryString.id_segment}`;
        r += `&${QueryString.KEY_R_ID_CUSTOMER}=${QueryString.id_customer}`;
        r += `&${QueryString.KEY_R_ID_SEGMENT}=${QueryString.id_segment}`;
        r += `&${QueryString.KEY_R_PARENT_APP}=${QueryString.parent_app}`;
        r += `&${QueryString.KEY_O_READ_ONLY}=${QueryString.is_read_only}`;
        r += `&${QueryString.KEY_O_FLOORPLAN_API_GATEWAY}=${Configuration.floorplan_api_gateway}`;
        r += `&${QueryString.KEY_O_WORKORDER_QUERY}=${encodeURIComponent(JSON.stringify(this.workorders_query))}`;
    
        // non-required fields. These could be null prior to the map being loaded 
        // when no drawing is selected

        if (exists(this.id_floor)) {
            r += `&${QueryString.KEY_O_ID_FLOOR}=${this.id_floor.value}`;
        }
        if (exists(id_building)) {
            r += `&${QueryString.KEY_O_ID_BUILDING}=${id_building.value}`;
        }
        if (exists(id_drawing)) {
            r += `&${QueryString.KEY_O_ID_DRAWING}=${id_drawing.value}`;
        }
        if (exists(QueryString.filter_finding_id_category)) {
            r += `&${QueryString.KEY_O_FILTER_FINDING_ID_CATEGORY}=${QueryString.filter_finding_id_category.value}`;
        }
        /*
            ?token=5GdCxxS9hNHnbPyXoWszpyx0jsNN4UaJD1kIqCU9KK1JaRlSdN4hG_31P_RIC7JQ_oCbyz1hpSlSbZagTq4-C43rOoZ7IERxvOZ_E5CbPNNbmWXYfkCmSqgyquvjE6GXedo_CjUCiQpUBaYU8-Fs-vLyNIORbS5U7d7luo5lG5FZSKVuHMP7FUdObgXujm6MAcVVH7tXKGy-2uOuYRFpxnyE2NUgYAk0rB9XGtBTnOO3WjrkNNPmJYVZzm-fs58wAzq5dD8sf1zk0byYDxVEUlQUaTuewe9_7W_4QtCi6K_Gnk8OyucMTO_zMEkTA0rA46qv_euqKO4rpnoNBea4BwqeBCCm_ngNivQHDWNmYCkXCfZqytyTM8DJa_esBNCr
            &api_gateway=https://cmsapi-dev.facsur.com
            &segmentid=11
            &customername=cms-test1
            &customerid=1
            &id_building=999
            &parent_app=cms_tech
            &workorderquery=%7B%7D
        */
    
    
        return r;
    }
}


// WEBPACK FOOTER //
// ./src/ts/redux/State.ts